<!--
 * @Description:
 * @Version: 1.0
 * @Autor: dudedu
 * @Date: 2022-12-02 13:09:28
 * @LastEditors: dudedu
 * @LastEditTime: 2022-12-09 15:57:07
-->
<template>
  <!-- 上传文件弹窗 -->
  <el-dialog
    :before-close="closeDialog"
    :close-on-click-modal="false"
    :visible.sync="dialogUploadVisible"
    class="dialogEDA"
    title="上传文件"
    width="1400px"
  >
    <el-upload
      v-if="machineImageTypeWindows"
      :auto-upload="false"
      :file-list="uploadFileList"
      :on-change="checkFileChange"
      :on-remove="checkFileRemove"
      action=""
      class="upload-demo"
      drag
      multiple
    >
      <i class="el-icon-upload"></i>
      <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
    </el-upload>
    <el-row v-else>
      <el-col :span="11" class="base-margin__right-20">
        <div style="line-height: 37px; height: 37px"></div>
        <div class="table">
          <el-table :data="uploadFileList" max-height="430">
            <el-table-column label="本地已选择文件" prop="name"></el-table-column>
            <!-- 文件大小 -->
            <el-table-column label="文件大小" width="100">
              <template slot-scope="scope">{{ sizeFilter(scope.row.size) }}</template>
            </el-table-column>
            <el-table-column label="状态" prop="fileStatus" width="120"></el-table-column>
            <el-table-column label="操作" width="50">
              <template slot-scope="scope">
                <span
                  class="base-cursor__pointer dialogTrueCls base-color__light_blue base-font-size__12px"
                  @click="deleteFileList(scope.$index, uploadFileList)"
                >
                  移除
                </span>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-col>
      <el-col :span="12">
        <div class="base-width_fullscreen">
          <div class="base-flex__cross-center base-font-size__14px base-flex__between">
            <span>
              <div>
                <span>云服务器当前路径： </span>
                <!--<el-input class="base-width__240" :disabled="true" v-model="pathInput"-->
                <!--          placeholder="请输入内容"></el-input>-->
                <span class="base-width__240">{{ pathInput }}</span>
              </div>
              <div class="base-flex">
                <el-button
                  :disabled="backPageBol"
                  class="base-margin__right-10 dialogTrueCls"
                  type="text"
                  @click="backPage"
                  >返回上一页
                </el-button>
                <el-button
                  class="base-margin__left-10 base-margin__right-10 dialogTrueCls"
                  type="text"
                  @click="returnRoot"
                  >返回根目录
                </el-button>
                <el-button
                  class="refresh dialogTrueCls base-text-align__right"
                  icon="el-icon-refresh"
                  title="刷新"
                  type="text"
                  @click="getDirectoryList"
                ></el-button>
              </div>
            </span>
            <el-dropdown class="base-margin__right-32">
              <span class="base-color__light_blue base-cursor__pointer">
                文件操作<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="file">
                  <p @click="createClusterFile('file')">
                    <span> 创建文件 </span>
                  </p>
                </el-dropdown-item>
                <el-dropdown-item command="dir">
                  <p @click="createClusterFile('dir')">
                    <span> 创建文件夹 </span>
                  </p>
                </el-dropdown-item>
                <el-dropdown-item>
                  <el-upload
                    :auto-upload="false"
                    :file-list="uploadFileList"
                    :on-change="handleFileChange"
                    :show-file-list="false"
                    action=""
                    multiple
                  >
                    <span> 上传文件 </span>
                  </el-upload>
                </el-dropdown-item>
                <el-dropdown-item>
                  <el-upload
                    ref="uploadFileRef"
                    :auto-upload="false"
                    :file-list="uploadFileList"
                    :on-change="handleFileChange"
                    :show-file-list="false"
                    action=""
                    multiple
                    webkitdirectory
                  >
                    <span> 上传文件夹 </span>
                  </el-upload>
                </el-dropdown-item>
                <!--<el-dropdown-item :disabled="selectionServerFileList.length === 0">-->
                <!--  <p @click="deleteServerFile(selectionServerFileList)">-->
                <!--    <span> 批量删除 </span>-->
                <!--  </p>-->
                <!--</el-dropdown-item>-->
              </el-dropdown-menu>
            </el-dropdown>
          </div>
          <div class="fileListTable">
            <el-table :data="tableData" max-height="400" v-loading="tableLoading">
              <!-- 文件名 -->
              <el-table-column label="文件名">
                <template slot-scope="scope">
                  <div v-if="scope.row.is_dir">
                    <i class="el-icon-folder-opened base-margin__right-5"></i>
                    <el-button class="dialogTrueCls" style="padding: 0" type="text" @click="openFolder(scope.row.name)"
                      >{{ scope.row.name }}
                    </el-button>
                  </div>

                  <div v-else>
                    <i class="el-icon-tickets base-margin__right-5"></i>
                    <span>{{ scope.row.name }}</span>
                  </div>
                </template>
              </el-table-column>
              <!-- 文件大小 -->
              <el-table-column label="文件大小" width="100">
                <template slot-scope="scope">{{ sizeFilter(scope.row.size) }}</template>
              </el-table-column>
              <el-table-column label="修改时间" width="150">
                <template slot-scope="scope">
                  {{ processTime(scope.row.mod_time) }}
                </template>
              </el-table-column>
              <el-table-column :label="$t('common.actions')" width="100">
                <template slot-scope="scope">
                  <!--<span v-if="!scope.row.is_dir">-->
                  <!--  <el-button-->
                  <!--    type="text"-->
                  <!--    v-if="taskForm.software !== 'vasp'"-->
                  <!--    @click="cosFileSelect(scope.row, 'master')"-->
                  <!--    >主文件上传</el-button-->
                  <!--  >-->
                  <!--  <el-button type="text" @click="cosFileSelect(scope.row, 'common')">{{-->
                  <!--    taskForm.software === 'vasp' ? '输入文件上传' : '普通文件上传'-->
                  <!--  }}</el-button>-->
                  <span>
                    <el-button
                      type="text"
                      class="dialogTrueCls"
                      v-if="!scope.row.is_dir"
                      @click="previewServerFile(`${pathInput}/${scope.row.name}`)"
                    >
                      {{ $t('customCluster.baseInfo.preview') }}
                    </el-button>
                    <el-button
                      type="text"
                      class="dialogTrueCls"
                      @click="deleteServerFile([`${pathInput}/${scope.row.name}`])"
                    >
                      {{ $t('common.delete') }}
                    </el-button>
                  </span>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </el-col>
    </el-row>
    <!--预览文件-->
    <el-dialog
      title="预览文件"
      :visible.sync="previewDialogVisible"
      :z-index="1000"
      :close-on-click-modal="false"
      width="600px"
    >
      <el-input v-model="previewContent" type="textarea" :rows="20" readonly class="error-textarea" />
    </el-dialog>

    <span v-if="machineImageTypeWindows" slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">取 消</el-button>
      <el-button :loading="uploadLoading" class="dialogTrueCls" type="primary" @click="machineImageTypeWindowsUpload"
        >上传</el-button
      >
    </span>
    <span v-else slot="footer" class="dialog-footer base-text-align__right">
      <div class="base-flex__cross-center">
        <el-button class="dialogTrueCls base-margin__right-10" size="small" @click="uploadFileList = []"
          >清空文件</el-button
        >
        <el-upload
          :auto-upload="false"
          :file-list="uploadFileList"
          :on-change="handleFileChange"
          :show-file-list="false"
          action=""
          multiple
        >
          <el-button class="dialogTrueCls" size="small">选择文件</el-button>
        </el-upload>

        <el-upload
          ref="uploadFileRef"
          :auto-upload="false"
          :file-list="uploadFileList"
          :on-change="handleFileChange"
          :show-file-list="false"
          action=""
          multiple
          webkitdirectory
        >
          <el-button class="base-margin__left-10 base-margin__right-10 dialogTrueCls" size="small"
            >选择文件夹</el-button
          >
        </el-upload>
        <el-button :loading="uploadLoading" class="dialogTrueCls" size="small" type="primary" @click="uploadFile">
          上传
        </el-button>
      </div>
    </span>
  </el-dialog>
</template>
<script>
import { cosSliceFile } from '@/common/utils/cosApi';
import { processTime } from '@/common/utils/utils';
import { postRequest } from '@/common/libs/request';
import { Message } from 'element-ui';

export default {
  name: 'uploadFile',
  props: {
    handleClose: {
      // 关闭弹窗
      type: Function,
      default: () => {},
    },
    linuxName: String,
    homePath: String,
    machineImageTypeWindows: Boolean,
  },
  data() {
    return {
      uploadFileList: [], // 上传的文件列表
      uploadLoading: false, // 上传文件loading
      dialogUploadVisible: false,
      pathInput: '',
      newLinuxName: '',
      processTime,
      currentPage: 1,
      pageSize: 10,
      tableDataTotal: 0,
      tableData: [],
      submitApprovalLoading: false,
      oldDirPath: '',
      defaultLinuxName: '',
      tableLoading: false,
      backPageBol: true,
      instanceId: '',
      vncUser: '',
      previewDialogVisible: false, // 预览内容
      previewContent: '', // 预览内容
    };
  },

  mounted() {
    this.instanceId = this.$route.query.instanceId;
    this.vncUser = this.$route.query.vncUser;
  },

  methods: {
    /**
     * 获取服务器文件列表
     */
    getDirectoryList() {
      this.tableLoading = true;
      const params = {
        instanceId: this.instanceId,
        dirPath: this.pathInput,
      };
      postRequest('/api/eda/common/project/getDirectoryList', params)
        .then((res) => {
          this.tableData = res?.list?.filter(item => item.name.charAt(0) !== '.') || [];
          this.oldDirPath = this.pathInput;
          this.tableLoading = false;
        })
        .catch(() => {
          // 接口错误后，返回默认值path
          this.pathInput = this.oldDirPath;
          this.tableLoading = false;
        });
    },

    /**
     * 打开文件夹弹窗
     */
    openDirectoryDialog(newVal) {
      this.newLinuxName = newVal;
      this.defaultLinuxName = newVal;
      // if (this.vncUser === 'root') {
      //   this.pathInput = this.homePath;
      //   this.oldDirPath = this.homePath;
      // }
      // if (this.vncUser === 'common') {
      //   this.pathInput = `${this.homePath}/${this.defaultLinuxName}`;
      //   this.oldDirPath = `${this.homePath}/${this.defaultLinuxName}`;
      // }
      // if (this.vncUser === 'loginSimple') {
      //   this.pathInput = `${this.homePath}`;
      //   this.oldDirPath = `${this.homePath}`;
      // }
      this.pathInput = `${this.homePath}/${this.defaultLinuxName}`;
      this.oldDirPath = `${this.homePath}/${this.defaultLinuxName}`;
      this.getDirectoryList();
    },
    /**
     * 打开文件夹
     */
    openFolder(name) {
      this.pathInput = `${this.pathInput}/${name}`.replace(/\/\//g, '/');
      this.getDirectoryList();
      this.backPageBol = false;
    },

    /**
     * 返回上一页
     */
    backPage() {
      this.pathInput = this.pathInput.substring(0, this.pathInput.lastIndexOf('/'));
      this.oldDirPath = this.pathInput;
      // if (this.vncUser === 'root') {
      //   if (this.pathInput === this.homePath) {
      //     this.backPageBol = true;
      //   }
      // }
      // if (this.vncUser === 'common') {
      //   if (this.pathInput === `${this.homePath}/${this.defaultLinuxName}`) {
      //     this.backPageBol = true;
      //   }
      // }
      //
      // if (this.vncUser === 'loginSimple') {
      //   if (this.pathInput === `${this.homePath}`) {
      //     this.backPageBol = true;
      //   }
      // }
      if (this.pathInput === `${this.homePath}/${this.defaultLinuxName}`) {
        this.backPageBol = true;
      }
      this.getDirectoryList();
    },

    /**
     * 返回根目录
     */
    returnRoot() {
      // if (this.vncUser === 'root') {
      //   this.pathInput = this.homePath;
      //   this.oldDirPath = this.homePath;
      // }
      // if (this.vncUser === 'common') {
      //   this.pathInput = `${this.homePath}/${this.defaultLinuxName}`;
      //   this.oldDirPath = `${this.homePath}/${this.defaultLinuxName}`;
      // }
      // if (this.vncUser === 'loginSimple') {
      //   this.pathInput = this.homePath;
      //   this.oldDirPath = this.homePath;
      // }
      this.pathInput = `${this.homePath}/${this.defaultLinuxName}`;
      this.oldDirPath = `${this.homePath}/${this.defaultLinuxName}`;
      this.backPageBol = true;
      this.getDirectoryList();
    },

    /**
     * 文件大小过滤
     */
    sizeFilter(value) {
      const text = '';
      const size = value / 1;
      if (size >= 1024 * 1024 * 1024) {
        return `${(size / 1024 / 1024 / 1024).toFixed(2)}G `;
      }
      if (1024 * 1024 < size && size < 1024 * 1024 * 1024) {
        return `${(size / 1024 / 1024).toFixed(2)}M`;
      }
      if (size < 1024 * 1024) {
        return `${(size / 1024).toFixed(2)}KB`;
      }
      return text || '0.00KB';
    },
    /**
     * 打开弹窗
     */
    openDialogUploadVisible() {
      this.dialogUploadVisible = true;
      if (this.machineImageTypeWindows) return;
      this.$nextTick(() => {
        this.$refs.uploadFileRef.$children[0].$refs.input.webkitdirectory = true;
        this.$refs.uploadFileRef.$children[0].$refs.input.directory = true;
      });
      this.openDirectoryDialog(this.linuxName);
    },

    /**
     * 关闭弹窗
     */
    closeDialog() {
      this.uploadFileList = [];
      this.handleClose();
      this.dialogUploadVisible = false;
    },

    /**
     * 移除文件
     */
    deleteFileList(index, rows) {
      rows.splice(index, 1);
    },

    /**
     * 上传文件时触发
     */
    checkFileChange(file) {
      this.uploadFileList.push(file);
    },

    checkFileRemove(file, fileList) {
      this.uploadFileList = fileList;
    },

    /**
     * 统一处理文件和文件夹上传
     * @param {Object} file 当前文件对象
     * @param {Array} fileList 当前文件列表
     */
    handleFileChange(file, fileList) {
      // 处理文件夹上传
      if (file.raw.webkitRelativePath) {
        const folderName = file.raw.webkitRelativePath.split('/')[0];
        const processedFiles = [];

        fileList.forEach((item) => {
          if (item.raw.webkitRelativePath) {
            // 只处理文件夹内的文件，不上传文件夹本身
            if (item.raw.webkitRelativePath.split('/').length > 1) {
              const fileName = `${folderName}/${item.raw.webkitRelativePath
                .split('/')
                .slice(1)
                .join('/')
                .replace(/\s+/g, '_')
                .replace(' ', '_')}`;
              const newFile = {
                ...item,
                name: fileName,
                fileStatus: '未上传',
                raw: new File([item.raw], fileName, {
                  type: item.raw.type,
                  lastModified: item.raw.lastModified,
                  webkitRelativePath: item.raw.webkitRelativePath,
                }),
              };
              processedFiles.push(newFile);
            }
          }
        });

        // 合并到uploadFileList，并去重
        this.mergeFilesToUploadList(processedFiles);
      } else {
        // 处理单个文件上传
        const fileName = `${file.name}`.replace(/\s+/g, '_').replace(' ', '_');
        const newFile = {
          ...file,
          name: fileName,
          fileStatus: '未上传',
          raw: new File([file.raw], fileName),
        };
        this.mergeFilesToUploadList([newFile]);
      }
    },

    /**
     * 合并文件到上传列表并去重
     * @param {Array} newFiles 新文件数组
     */
    mergeFilesToUploadList(newFiles) {
      // 过滤掉已存在的文件
      const uniqueFiles = newFiles.filter(newFile => !this.uploadFileList.some(existingFile => existingFile.name === newFile.name));

      if (uniqueFiles.length > 0) {
        this.uploadFileList = [...this.uploadFileList, ...uniqueFiles];
      }
    },

    /**
     * 文件上传
     */
    uploadFile() {
      try {
        this.uploadLoading = true;
        if (this.uploadFileList.length !== 0) {
          this.uploadLoading = false;
          this.uploadFileList.forEach((item) => {
            item.fileStatus = '上传中';
            cosSliceFile(item.raw, {}, (progress) => {
              // 实时更新上传进度
              item.fileStatus = `上传中(${progress}%)`;
            })
              .then(() => {
                this.syncCosToDist(item);
              })
              .catch(() => {
                item.fileStatus = '上传失败';
              });
          });
        } else {
          this.uploadLoading = false;
          this.$message('请选择需要上传的文件');
        }
      } catch {
        this.uploadLoading = false;
      }
    },
    /**
     * 同步COS数据到实例的指定目录
     */
    syncCosToDist(file) {
      const params = {
        cosFilePath: `/${this.linuxName}/${file.name}`,
        instanceId: this.instanceId,
        instanceFilePath: `${this.pathInput}/${file.name}`,
      };

      params.instanceFilePath = params.instanceFilePath.replace(/\/\//g, '/');

      postRequest('/api/eda/common/cluster/syncCosToDist', params)
        .then(() => {
          this.getDirectoryList();
          file.fileStatus = '上传成功';
          this.uploadFileList.splice(this.uploadFileList.indexOf(file), 1);
        })
        .catch(() => {
          file.fileStatus = '上传失败';
          this.uploadLoading = false;
        });
    },

    /**
     * 文件上传
     */
    machineImageTypeWindowsUpload() {
      this.uploadLoading = true;
      if (this.uploadFileList.length !== 0) {
        Promise.all(this.uploadFileList.map(item => cosSliceFile(item.raw), {}))
          .then(() => {
            this.uploadFileList = [];
            this.uploadLoading = false;
            this.$message.success('上传成功');
            this.handleClose('sync');
            setTimeout(() => {
              this.getDirectoryList();
            }, 2000);
          })
          .catch(() => {
            this.uploadLoading = false;
          });
      } else {
        this.uploadLoading = false;
        this.$message('请选择需要上传的文件');
      }
    },

    /**
     * 创建文件、文件夹
     */
    createClusterFile(val) {
      this.$prompt(`请输入${val === 'dir' ? '目录' : '文件'}名称`, `创建${val === 'dir' ? '目录' : '文件'}`, {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputErrorMessage: '名称不能为空',
      })
        .then(({ value }) => {
          this.tableLoading = true;
          postRequest('/api/eda/common/cluster/createClusterFile', {
            instanceId: this.instanceId,
            filePath: `${this.pathInput}/${value}`,
            fileType: val,
          }).then(() => {
            Message.success(`创建${value}${val === 'dir' ? '目录' : '文件'}成功`);
            this.getDirectoryList();
          });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: `取消创建${val === 'dir' ? '目录' : '文件'}`,
          });
        });
    },

    /**
     * 删除服务器文件
     */
    deleteServerFile(files) {
      this.$confirm('确定删除文件/文件夹？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.tableLoading = true;
          postRequest('/api/eda/common/cluster/removeClusterFile', {
            instanceId: this.instanceId,
            files,
          })
            .then(() => {
              this.getDirectoryList();
            })
            .catch(() => {
              this.tableLoading = false;
            });
        });
    },

    /**
     * 预览服务器文件
     */
    previewServerFile(file) {
      this.$message.warning('获取文件内容中，请稍后！');
      this.fileDirectoryLoading = true;
      postRequest('/api/eda/common/cluster/describeFileContent', {
        filePath: file,
      })
        .then((res) => {
          this.fileDirectoryLoading = false;
          if (res.content === '') {
            this.previewContent = this.$t('customCluster.manage.noData');
          } else {
            this.previewContent = res.content;
          }
          this.previewDialogVisible = true;
        })
        .catch(() => {
          this.fileDirectoryLoading = false;
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.dialogEDA {
  ::v-deep .el-dialog__header {
    text-align: left !important;
  }
}

// table 背景颜色+padding10px
.table {
  background: #fff;
  border: 1px solid #eee;
  //box-shadow: #8c939d 0 0 10px;
  border-radius: 4px;
  //padding: 10px;
  // table内容部分下边距和最小高度
  .el-table {
    min-height: 430px;
    max-height: 430px;
  }
}

.fileListTable {
  background: #fff;
  border: 1px solid #eee;
  //box-shadow: #8c939d 0 0 10px;
  border-radius: 4px;
  //padding: 10px;
  // table内容部分下边距和最小高度
  .el-table {
    min-height: 410px;
    max-height: 410px;
  }
}

.dialogTrueCls {
  background-image: none !important;
}
</style>
